import { InteractionStatus } from '@azure/msal-browser';
import { useMsal } from '@azure/msal-react';
import logo from '@src/main/assets/images/iberia-title.svg';
import backgroundImage from '@src/main/assets/images/sunset.webp';
import { useAuth } from '@src/main/shared/context/AuthContext';
import { logger } from '@src/main/shared/utils/logger';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import './Login.scss';

export const Login: React.FC = () => {
  const { instance, inProgress } = useMsal();
  const { t } = useTranslation();
  const { user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  // eslint-disable-next-line no-undef
  const version = APP_VERSION;

  useEffect(() => {
    if (user) {
      const from = (location.state as { from?: Location })?.from?.pathname || '/home';
      navigate(from !== '/login' ? from : '/home', { replace: true });
    }
  }, [user, location, navigate]);

  const handleLogin = () => {
    if (inProgress === InteractionStatus.None) {
      instance
        .loginRedirect({
          scopes: ['openid', 'profile', 'email'],
          prompt: 'select_account',
          redirectUri: `${window.location.origin}/login`,
        })
        .catch((error) => {
          logger.error('Login error:', error);
        });
    } else {
      logger.info('Login skipped: interaction in progress');
    }
  };

  return (
    <div className="login-container" style={{ backgroundImage: `url(${backgroundImage})` }}>
      <div className="login-content">
        <div className="login-header">
          <h3>{t('common.appName')}</h3>
          <div className="logo-container">
            <img src={logo} alt="Iberia Logo" />
          </div>
        </div>
        <div className="login-body">
          <button onClick={handleLogin} className="login-button">
            {t('common.login')}
          </button>
          <div className="login-footer">
            <span>© IBERIA</span>
            <span className="version">{version}</span>
          </div>
        </div>
      </div>
    </div>
  );
};
